// src/App.tsx
import { BrowserRouter } from 'react-router-dom';
import { TenantThemeProvider } from '@vanialabs/ui-engine';
import { AppRouter } from './app/router/AppRouter';
import { ThemeEngineProvider, themeEngine } from './app/theme/ThemeEngineProvider';
import { ErrorBoundary } from './app/components/ErrorBoundary';
import { DashboardHydrationBoundary } from './features/dashboard/DashboardHydrationBoundary';

/**
 * Composition root only. Deliberately kept free of routing/layout/data
 * logic — those live in ./app/router, ./app/layout, and each feature.
 * Mirrors representative-admin's App.tsx.
 *
 * Phase 4.7: <TenantThemeProvider> wraps the tree using the existing
 * module-scoped `themeEngine` instance exported from
 * ./app/theme/ThemeEngineProvider — no new ThemeEngine is constructed.
 * `binding` stays `null` as a placeholder; no tenant fetching is
 * introduced here.
 */
export function App() {
  return (
    <DashboardHydrationBoundary>
      <ThemeEngineProvider>
        <TenantThemeProvider binding={null} themeEngine={themeEngine}>
          <BrowserRouter>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </BrowserRouter>
        </TenantThemeProvider>
      </ThemeEngineProvider>
    </DashboardHydrationBoundary>
  );
}
